import {StoreType} from '..';
//types
import {IUserOrganizationSettingData, IVipPhoneData} from '../../utils/types';

export const getAllPhoneNumbersSelector = (state: StoreType): IVipPhoneData[] =>
	state.organizationNotificationStore.organizationVipPhones;

export const vipPhoneNumbersLoaderSelector = (state: StoreType): boolean =>
	state.organizationNotificationStore.isLoading;

export const organizationNotificationSettingSelector = (state: StoreType): IUserOrganizationSettingData | null =>
	state.organizationNotificationStore.organizationSetting;

export const organizationNotificationSettingLoaderSelector = (state: StoreType): boolean =>
	state.organizationNotificationStore.isLoading;
